export default "__VITE_ASSET__C0wOzZK7__"